import settings from "../../../constants/settings";
import useFetchAndTrace from "../fetchWithTrace";
import { useState } from "react";
import { useCustomAlert } from "../alerts";

export default function useDeleteContainers(
  onDelete?: () => void,
  onError?: () => void,
) {
  const fetchAndTrace = useFetchAndTrace();
  const customAlert = useCustomAlert();
  const [loading, setLoading] = useState<boolean>(false);

  const deleteContainerHandler = async (response: Response) => {
    if (response.ok) {
      setLoading(false);
      onDelete?.();
    } else if (response.status === 400) {
      setLoading(false);
      const { detail } = (await response.json()) as { detail: string };
      customAlert(detail);
      onError?.();
    } else {
      throw new Error("Failed to delete container.");
    }
  };

  const errorHandler = () => {
    setLoading(false);
    customAlert("Failed to delete container.");
    onError?.();
  };

  const deleteContainers = (containersToDelete: string[]) => {
    setLoading(true);
    void fetchAndTrace(
      `${settings.api_url}/inventory/containers/delete`,
      deleteContainerHandler,
      errorHandler,
      {
        body: JSON.stringify({
          containers: containersToDelete,
        }),
        method: "PUT",
      },
    );
  };
  return { deleteContainers, deletingContainers: loading };
}
